/**
 * Deep-freezes a runtime config.
 *
 * `AgentRuntimeConfig` is immutable in the type (`readonly` throughout) *and* at runtime.
 * Freezing is idempotent and structural; it never copies, so identity is preserved and the
 * config-cache can key on it.
 */
export function deepFreezeRuntimeConfig(config) {
    freeze(config, new WeakSet());
    return config;
}
function freeze(value, seen) {
    if (value === null || typeof value !== "object")
        return;
    const subject = value;
    if (seen.has(subject))
        return;
    seen.add(subject);
    Object.freeze(subject);
    for (const entry of Object.values(subject))
        freeze(entry, seen);
}
//# sourceMappingURL=runtime-config.js.map